import { ActionableNotification, Stack } from "@carbon/react";
import React from "react";
import { HelpCenterTile } from "../tile";
import styled from "styled-components";
export const TAB_TYPES = {
    Grid: "grid",
    Column: "column",
};
export const TileWrapper = styled.div `
	display: flex;
	flex-wrap: wrap;
	justify-content: flex-start;
	gap: var(--cds-spacing-05);
`;
export const TabContent = ({ onboarding, type, origin, tiles, mixpanelTrack }) => {
    return (React.createElement("div", null,
        React.createElement(Stack, null,
            onboarding && onboarding?.complete !== true && (React.createElement(ActionableNotification, { kind: "info", inline: true, lowContrast: true, hideCloseButton: true, style: { maxWidth: "100%", marginBottom: "1rem" }, actionButtonLabel: "Resume survey", onActionButtonClick: onboarding.resumeSurvey, title: "Complete the new user survey to see more recommendations", subtitle: "" })),
            React.createElement(TileWrapper, null, tiles.map((tile) => (React.createElement(HelpCenterTile, { origin: origin, tabType: type, tile: tile, mixpanelTrack: mixpanelTrack, key: tile.card_id })))))));
};
